import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";

export default makeStyles((theme: MuiTheme) => {
  const {
    divider,
    common: { white }
  } = theme.palette;

  return {
    root: {
      display: "flex",
      flexDirection: "column",
      [theme.breakpoints.up("md")]: {
        background: "#fff",
        boxShadow: "0px 1px 7px 0 rgba(0,0,0,0.1)",
        borderRadius: 3
      }
    },
    maxHeight: {
      [theme.breakpoints.up("md")]: {
        maxHeight: "100%",
        height: "100%"
      }
    },
    header: {
      fontSize: 18,
      marginBottom: 12,
      [theme.breakpoints.up("md")]: {
        display: "none"
      }
    },
    subHeader: {
      fontSize: 16,
      color: "#676868",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      backgroundColor: white,
      borderBottom: `1px solid ${divider}`,
      [theme.breakpoints.up("md")]: {
        padding: "12px 16px 13px",
        margin: 0,
        fontSize: 14,
        fontFamily: "SuisseIntlMedium, SuisseIntlRegular",
        top: 0,
        zIndex: 2
      }
    },
    content: {
      position: "relative",
      [theme.breakpoints.up("md")]: {
        flex: "auto",
        overflow: "auto"
      },
      [theme.breakpoints.down("sm")]: {
        background: "#fff",
        boxShadow: "0px 1px 7px 0 rgba(0,0,0,0.1)",
        borderRadius: 3
      }
    },
    viewMoreButton: {
      width: "100%",
      minHeight: 38,
      padding: 0,
      border: 0,
      background: "transparent",
      color: theme.palette.text.secondary,
      fontFamily: "SuisseIntlRegular",
      fontSize: 12,
      textTransform: "none",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      cursor: "pointer"
    },
    viewMoreIcon: {
      fontSize: 14,
      marginLeft: 4
    },
    viewLessIcon: {
      transform: "rotate(180deg)"
    }
  };
});
